import React from 'react';
import { IconSvgProps } from '@models/common';

const PlagiarismPaste: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8.5 5H6C4.89543 5 4 5.89543 4 7V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V7C20 5.89543 19.1046 5 18 5H15.5'
        stroke='var(--color-secondary)'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M8 7.4V5.5C8 5.22386 8.22386 5 8.5 5C8.77614 5 9.00422 4.77604 9.05152 4.50398C9.19968 3.65171 9.77399 2 12 2C14.226 2 14.8003 3.65171 14.9485 4.50398C14.9958 4.77604 15.2239 5 15.5 5C15.7761 5 16 5.22386 16 5.5V7.4C16 7.73137 15.7314 8 15.4 8H8.6C8.26863 8 8 7.73137 8 7.4Z'
        stroke='var(--color-secondary)'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default PlagiarismPaste;
